import React from "react";
import { IProps } from "../component";
import { Input, Form } from 'antd'

const { Search } = Input

export const InputGroup = (props: IProps) => {
  const { properties } = props.json;
  const buttonCallBack = () => {
    return 0
  }

  return (
    <Form.Item
        className={'a8-form-item override-common'}
        label={properties.label || 'Group'}
    >
        <Search placeholder={properties.placeholder || 'Enter a value'} enterButton={properties.buttonText ? properties.buttonText.toUpperCase() : 'BUTTON'} loading={false} onSearch={buttonCallBack}></Search>
    </Form.Item>
  );
};
